import React, { FC, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { LogIn } from 'lucide-react';
import { Button } from '@pisaka/ui';
import { useModal } from '../../../hooks/useModal';
import { MODAL_NAME_AUTH } from '../../../constants/modalNamesConstants';
import FontCreatorNotAuthControlPanelContainer from './FontCreatorNotAuthControlPanelContainer';
import { REGISTER_STATE_TYPE } from '../../auth/authTypes';

const FontCreatorNotAuthContainer: FC = () => {
  const { t } = useTranslation();
  const { onOpenModal } = useModal(MODAL_NAME_AUTH);

  const onOpenRegisterModal = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onOpenModal({ selectedAuthStateType: REGISTER_STATE_TYPE });
  };

  const onOpenAuthModal = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onOpenModal();
  };

  return (
    <>
      <FontCreatorNotAuthControlPanelContainer />
      <div className="flex items-center justify-center h-emptyHeight px-6">
        <div className="flex flex-col items-center gap-4 text-center max-w-sm">
          <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center">
            <LogIn className="w-8 h-8 text-muted-foreground" />
          </div>
          <div>
            <p className="text-base font-semibold">{t('fontCreator.notAuthTitle')}</p>
            <p className="text-sm text-muted-foreground mt-1">{t('fontCreator.notAuthDescription')}</p>
          </div>
          <div className="flex gap-3">
            <Button
              variant="outline"
              onClick={onOpenAuthModal}
            >
              {t('fontCreator.notAuthLogin')}
            </Button>
            <Button
              onClick={onOpenRegisterModal}
              className="bg-gradient-accent hover:bg-accent shadow-accent text-primary-foreground"
            >
              {t('fontCreator.notAuthRegister')}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FontCreatorNotAuthContainer;
